import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Storytelling } from '../components/Storytelling';
import { Services } from '../components/Services';
import { NailsGallery } from '../components/NailsGallery';
import { BrowsGallery } from '../components/BrowsGallery';
import { HairGallery } from '../components/HairGallery';
import { Testimonials } from '../components/Testimonials';
import { InstagramReel } from '../components/InstagramReel';
import { BookingBanner } from '../components/BookingBanner';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="w-full min-h-screen" data-id="element-183">
      <Navbar data-id="element-184" />
      <Hero data-id="element-185" />
      <Storytelling data-id="element-186" />
      <Services data-id="element-187" />
      <NailsGallery data-id="element-188" />
      <BrowsGallery data-id="element-189" />
      <HairGallery data-id="element-190" />
      <Testimonials data-id="element-191" />
      <InstagramReel data-id="element-192" />
      <BookingBanner data-id="element-193" />
      <Footer data-id="element-194" />
    </main>;
}